// @index(['./!(*.spec).ts', './*/index.ts'], f => `export * from '${f.path.replace(/\/index$/, '')}';`)
export * from './address.model';
export * from './area-price.model';
export * from './area.model';
export * from './city.model';
export * from './customer.model';
export * from './email.model';
export * from './role.model';
export * from './status.model';
export * from './template.model';
export * from './upload-file.model';
export * from './user-lock.model';
export * from './user-session.model';
export * from './user.model';
// @endindex